import {Checkbox, Col, Row, Space} from "antd";
import React, {useState, useEffect} from "react";
import "./PopoverTable.scss";
import {ColumnProps} from "types/models";
import {saveTableOptions} from "helper/common";

const ColumnPopoverDisplay = (props) => {
  const {
    setShowColumns,
    columns,
    width = "250px",
    columnSizes = {
      xs: 24,
      sm: 24,
      md: 12,
      lg: 12,
      xl: 12,
    }, // Giá trị mặc định
  } = props;
  const [displayColumns, setDisplayColumns] = useState<any>(columns);
  const onChange = (column: ColumnProps) => {
    var showColumns = displayColumns.map(e => {
      if (e.dataIndex == column.dataIndex) {
        return {...e, show: !e.show || Boolean(e.default)};
      }
      return e;
    });

    setDisplayColumns(showColumns);
    setShowColumns(showColumns.filter(e => e.show == true));
  };
  useEffect(() => {}, [displayColumns]);
  return (
    <Space
      className="column-display-contentt"
      style={{width}}
      direction="vertical"
      size={8}
    >
      <Row>
        {displayColumns.map((column, index) => (
            <Col
                key={index}
                xs={columnSizes.xs} // Sử dụng giá trị từ prop columnSizes
                sm={columnSizes.sm}
                md={columnSizes.md}
                lg={columnSizes.lg}
                xl={columnSizes.xl}
            >
            <Checkbox
              checked={column.show}
              onChange={e => {
                onChange(column);
              }}
              value={column.show}
              disabled={column.disabledCheck}
            >
              {column.title}
            </Checkbox>
          </Col>
        ))}
      </Row>
    </Space>
  );
};

export default ColumnPopoverDisplay;
